import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';
import { RewardInfoData } from '../reward-info/reward-info.component';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';

@Component({
  selector: 'app-reward-info-modal',
  templateUrl: './reward-info-modal.component.html',
  styleUrls: ['./reward-info-modal.component.scss'],
})

/**
 * Modal for Reward info and actions.
 */
export class RewardInfoModalComponent implements OnInit {
  descriptionLabel = 'reward-info-modal-label';
  rewardInfoData!: RewardInfoData;
  reward!: RewardResponseDTO;

  /**
   * Constructor
   */
  constructor(
    public readonly dialogRef: MatDialogRef<RewardInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      reward: RewardResponseDTO;
      availableFamilies: any[];
      availableBusinessLevels: any;
      deleteHandler?: (reward: RewardResponseDTO) => void;
    },
    private readonly dialogService: DialogService
  ) {}

  /**
   * Lifecycle hook that is called after data-bound properties are initialized
   */
  ngOnInit(): void {
    this.reward = this.data.reward;

    this.rewardInfoData = {
      rewardType: {
        value: this.reward.rewardType,
        label: this.reward.rewardType,
      },
      relatedProductName: this.reward.product?.name,
      name: RewardResponseDTO.getLocalizedName(this.reward.rewardTitles, 'en'),
      nameEn: RewardResponseDTO.getLocalizedName(
        this.reward.rewardTitles,
        'en'
      ),
      namePt: RewardResponseDTO.getLocalizedName(
        this.reward.rewardTitles,
        'pt'
      ),
      nameEs: RewardResponseDTO.getLocalizedName(
        this.reward.rewardTitles,
        'es'
      ),
      redemptionLimit: this.reward.redemptionLimit,
      rewardCost: this.reward.cost,
      rewardCode: this.reward.rewardCode,
      extensionPeriod: this.reward.extensionPeriod,
      vipLevels: this.reward.businessLevelIds,
      vipOnly: this.reward.vipOnly,
      families: this.reward.familiesIds,
      locationRestrictions: this.reward.rewardExceptions,
    };
  }

  /**
   * Action to close the dialog
   * @param {boolean} event - The event indicating if the reward is deleted or not.
   */
  onDialogClose(event?: boolean) {
    this.dialogRef.close(event);
  }
}
